import { CxFooter } from '@cx-web/components/composites';
import { type RepubIs } from '@cx-web/utils';
import { useCmpProps } from '@cx-web/utils/cmp';

import FooterOC from '~/apps/product-plus/components/FooterOC';
import FooterWS from '~/apps/product-plus/components/FooterWS';
import { useLayoutStore } from '~/providers/layout-store-provider';

import styles from './styles/Footer.module.css';

export type FooterProps = {
  repubIs: RepubIs;
  resourcesUrl: string;
};

export default function Footer({ repubIs, resourcesUrl }: FooterProps) {
  const footerData = useLayoutStore(s => s.footerData);
  const isAdmiralCookieBannerEnabled = useLayoutStore(s => s.isAdmiralCookieBannerEnabled);
  const cmpProps = useCmpProps();

  const renderProductPlusFooter = () => {
    if (repubIs.WS) {
      return <FooterWS resourcesUrl={resourcesUrl} />;
    }

    if (repubIs.OC) {
      return <FooterOC />;
    }

    if (repubIs.GZ) {
      return null;
    }

    return (
      <CxFooter
        cmpProps={cmpProps}
        footerData={footerData}
        isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
        resourcesUrl={resourcesUrl}
      />
    );
  };

  return (
    <footer className={styles.footer} id="mainAppFooter">
      {renderProductPlusFooter()}
    </footer>
  );
}
